import type { FaireProductEntity } from "../../entity_types/product";

export const p_p4aspwc8af: FaireProductEntity = {
  token: "p_p4aspwc8af",
  type: "product",
  name: "Jimothy Soy Candle - Limited Run Series",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/1330bd74b77a0e1cfe6bd06a5008b4576e302fac7a15a884d85d20144d936b25.png",
  galleryImageUrls: [],
  priceDollars: 13,
  description:
    "Scent Notes: Rain-Soaked Cedar • Moss • Blackberry Bramble\nThe Vibe: Late-night neighborhood adventures.\n\nSeattle's favorite little legend.\n\nJimothy may be small, but he's become one of Seattle's biggest icons. Inspired by everyone's favorite Ballard raccoon, this limited-edition candle captures the scent of damp cedar forests, blackberry brambles, and misty Pacific Northwest evenings.\n\nAs part of our commitment to 1% for the Planet, 1% of every Jimothy candle sold will be donated to Conservation Northwest, supporting their work to protect wildlife and wild places throughout the Pacific Northwest.\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:59.052Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
